export default __webpack_public_path__ + "static/media/share.3bc96137.svg";